/**
 * Provides the React context used to share the active session value across components.
 */
import { createContext } from 'react';

// Empty string preserves the existing default session value before a provider is mounted.
const SessionContext = createContext('');

export default SessionContext;
